export default "__VITE_ASSET__CEY47gmV__"